import { Administrator, AdministratorIO } from './administrator';
import { Serializer } from '@core/resources/serializer';

export class AdministratorSerializer implements Serializer<Administrator> {
  fromJson(json: AdministratorIO): Administrator {
    return new Administrator(json);
  }

  toJson(resource: Administrator): Partial<AdministratorIO> {
    return {
      email: resource.email,
      password: resource.password,
      first_name: resource.first_name,
      last_name: resource.last_name,
      features: resource.features,
      products: resource.products,
      id: resource.id,
      is_active: resource.is_active,
      is_enabled: resource.is_enabled
    };
  }
}
